import React from "react";
import screenNotFound from "../../assets/images/screen_not_found.png"

interface IProps {
    isLoading: boolean
}

export default function NotFound({isLoading}: IProps) {
    if (isLoading) {
        return null
    }
    return (
        <div className={"w-full  flex flex-col items-center justify-center"}>
            <img alt={"not found"} src={screenNotFound} className={"h-64 w-64 mt-36"} />
            <p className={"text-center mt-3 font-semibold text-lg text-gray-1"}>Sorry, we coudn’t find that page.</p>

            <p className={"text-base text-gray-1 mt-6 text-center"}>
                We’re sorry, the page you requested could not be found. Please contact customer support through email at {<span className={"underline text-blue-500"}>
                support@mdland.com
                </span>}.
            </p>
        </div>
    )
}